import PublicBetaNoticePage from './PublicBetaNoticePage';
import { PUBLIC_BETA_NOTICE_LAST_UPDATED } from './publicBetaNoticeContent';

const PrivacyPolicy = () => (
  <PublicBetaNoticePage title="Privacy Policy" lastUpdated={PUBLIC_BETA_NOTICE_LAST_UPDATED} />
);

export default PrivacyPolicy;
